import type { FaireProductEntity } from "../../entity_types/product";

export const p_2av5wz3x5c: FaireProductEntity = {
  token: "p_2av5wz3x5c",
  type: "product",
  name: "Wholesale Lot 2 Lbs Angel Aura Rose Quartz Tumble Healing",
  brandToken: "b_edj9u7j4sq",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/02f1c5f95983504021c35eaceae5964e17ef299e1b5fc6c6f15fe9198443ac42.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dc3ddc02f3cb7c899b16714e339c013ef3efaba12d15130107692e2949ec1c27.jpeg",
    "https://cdn.faire.com/fastly/5f2ac35eacc426c923e26b15894ba17991852177f28c82d7cb17b5da30670ca6.jpeg",
    "https://cdn.faire.com/fastly/1ff96b1e40792a6c1f0f1b9a20a54187a5fd523de3215cab34ad66c14fe39d33.jpeg",
    "https://cdn.faire.com/fastly/096090920a25380075ae5caa6b57c16ab14150e972d6c27f7fa98e3b0d12c91b.jpeg",
    "https://cdn.faire.com/fastly/c05e481990934069bc702dd54ff857d645ea3e098f7b0744a7c98bed69cac098.jpeg",
    "https://cdn.faire.com/fastly/1d03f8bba0fa279be2828cbc620f2241aeefa206298b4c9d763b85b77164cef2.jpeg",
    "https://cdn.faire.com/fastly/b44eadaf1795757a7def9f01e6ceed2d6959814fcb4a6c130dfabed967e92618.jpeg",
    "https://cdn.faire.com/fastly/0a0584b4bd27be003de66b4a2f938aa3ce7105a74d65b10de1af40964b71d4e7.jpeg",
  ],
  priceDollars: 48.5,
  description:
    "Enhance your crystal inventory with this vibrant wholesale lot of Bubblegum Aura Rose Quartz tumbled stones. Each lot includes approximately 2 lbs of beautifully polished crystals, featuring a soft pink hue with an eye-catching iridescent aura coating that gives each piece a unique, luminous finish.\n\nRose Quartz is sourced from Madagascar and is known for its gentle color and natural variations. These tumbled stones are perfect for retail display, crystal kits, crafting, or metaphysical use.\n\n\t•\tCondition: New\n\nPlease note: Due to the natural properties of Rose Quartz, pieces may vary in size, shape, and color, and may contain natural inclusions, cracks, or surface imperfections.\n\nFree domestic shipping or local pickup is available in Brooklyn, New York. \n\nStones, stone, crystal, crystals, crystals bulk, crystals wholesale, spiritual, spiritual items, meditation, metaphysical wholesale.",
  tags: [],
  msrpDollars: 97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:14.775Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
